module.exports = __webpack_public_path__ + "static/media/long-arrow-down.4833b991.svg";